<template>
  <WaggonInfoBody
    :color="workpackage.color"
    :workpackage="workpackage"
    :info_box="wallet || $vuetify.breakpoint.smAndDown?false:true"
    :wallet="wallet"
    >
    <template #body-content>
      <StandardFlexBox
        v-if="material"
        direction="column"
        align_content="center"
        justify_content="center"
        height="calc(100% - 36px)"
        >
        <div
          :class="`mb-1 ${workpackage.color}--text text--darken-3 font-weight-medium`"
          >
          {{$t('Project.Workpackage.NoSteps.MaterialStep')}}
        </div>
      </StandardFlexBox>
      <StandardFlexBox
        v-else
        direction="column"
        align_content="center"
        justify_content="center"
        height="calc(100% - 36px)"
        >
        <div
          :class="`mb-1 ${workpackage.color} text--darken-3 font-weight-medium`"
          v-if="!workpackage.tworksteps ||
              workpackage.twork_step_count === 0"
          >
          {{$t('Project.Workpackage.NoSteps.WorkStep')}}
        </div>
        <div
          :class="`mb-1 ${workpackage.color} text--darken-3 font-weight-medium`"
          v-if="!workpackage.tqualitysteps ||
              workpackage.tquality_step_count === 0"
          >
          {{$t('Project.Workpackage.NoSteps.QualityStep')}}
        </div>
        <div
          :class="`mb-1 ${workpackage.color} text--darken-3 font-weight-medium`"
          v-if="!workpackage.tdefectsteps ||
              workpackage.tdefect_step_count === 0"
          >
          {{$t('Project.Workpackage.NoSteps.DefectStep')}}
        </div>
        <div
          :class="`mb-1 ${workpackage.color} text--darken-3 font-weight-medium`"
          v-if="!workpackage.thandoversteps ||
              workpackage.thandover_step_count === 0"
          >
          {{$t('Project.Workpackage.NoSteps.HandoverStep')}}
        </div>
        <div
          :class="`mb-1 ${workpackage.color} text--darken-3 font-weight-medium`"
          v-if="!workpackage.tdesignsteps ||
              workpackage.tdesign_step_count === 0"
          >
          {{$t('Project.Workpackage.NoSteps.DesignStep')}}
        </div>
        <div
          :class="`mb-1 ${workpackage.color} text--darken-3 font-weight-medium`"
          v-if="!workpackage.tlogisticsteps ||
              workpackage.tlogistic_step_count === 0"
          >
          {{$t('Project.Workpackage.NoSteps.LogisticStep')}}
        </div>
        <div
          :class="`mb-1 ${workpackage.color} text--darken-3 font-weight-medium`"
          v-if="!workpackage.tcoststeps ||
              workpackage.tcost_step_count === 0"
          >
          {{$t('Project.Workpackage.NoSteps.CostStep')}}
        </div>
      </StandardFlexBox>
    </template>
  </WaggonInfoBody>
</template>
<script>

import { WaggonInfoMixin } from '@/mixins/WaggonInfo.mixin.js'

export default {
  props: ['project_id', 'train_id', 'taktarea_id', 'twaggon_id', 'tworkpackage_id', 'workpackage', 'wallet', 'material'],
  mixins: [
    WaggonInfoMixin
  ],
}
</script>
<style>
  div {
    user-select: none;
  }
</style>
